import React from 'react';
import {List, ListItem} from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Subheader from 'material-ui/Subheader';

export default (props) => {
  return (
    <List {...props}>
      <Subheader>New Users</Subheader>
      {props.customers.map(user => (
        <ListItem
          primaryText={`${user.firstName || ''} ${user.lastName || ''}`}
          secondaryText={user.email}
          leftAvatar={<Avatar src={user.avatar && user.avatar.url || 'https://pingendo.github.io/pingendo-bootstrap/assets/user_placeholder.png'} />}
          />
      ))}
    </List>
  )
}



// WEBPACK FOOTER //
// ./src/components/CustomerList.js